import CryptoJS from '../assets/crypot-js.min.js'
const SECRET_KEY = CryptoJS.enc.Utf8.parse("1592759630966666");
const SECRET_IV = CryptoJS.enc.Utf8.parse("4578244512125455");
export default {
	SECRET_KEY,
	SECRET_IV
}